<template>
  <SettingSchedule appName="cm-embarcador"/>
</template>

<script>
import SettingSchedule from '@/components/shares/schedule/Setting'

export default {
  components: { SettingSchedule },
  name: 'Setting'
}
</script>

<style scoped>

</style>
